import classNames from 'classnames'
import { BaseModalHeader } from '../base-modal'
import styles from './ModalSheetHeader.module.scss'
import type { ModalSheetHeaderProps } from './types'
import { MODAL_SHEET_HEADER_TITLE_ID } from './types'

const ModalSheetHeader = ({
  className,
  children,
  subtitle,
  title,
  ...props
}: ModalSheetHeaderProps) => {
  return (
    <BaseModalHeader
      className={classNames(styles['pintxo-modal-sheet__header'], className)}
      {...props}
    >
      {children && (
        <div className={styles['pintxo-modal-sheet__header__illustration']}>{children}</div>
      )}
      <div className={styles['pintxo-modal-sheet__header__text']}>
        <span
          className={classNames(
            styles['pintxo-modal-sheet__header__text__title'],
            'pintxo-typography-title2'
          )}
          id={MODAL_SHEET_HEADER_TITLE_ID}
        >
          {title}
        </span>
        {subtitle && (
          <span
            className={classNames(
              styles['pintxo-modal-sheet__header__text__subtitle'],
              'pintxo-typography-body1'
            )}
          >
            {subtitle}
          </span>
        )}
      </div>
    </BaseModalHeader>
  )
}
export default ModalSheetHeader
